export default __webpack_public_path__ + "static/media/accountCircle.a85e57dd.svg";